<ion-row class="phi-align-items-center">
  <ion-col size>
    <h5 class="ml-10 fw-b">Skip Day {{ !matDialogData?.applSkipRejectOrAccept ? 'Approval' : 'Details' }}</h5>
  </ion-col>
  <ion-col size="auto">
    <button matButton mat-dialog-close class="dialog_btns close_btn"><ion-icon name="close-outline"></ion-icon></button>
  </ion-col>
</ion-row>

<mat-dialog-content>
  <div class="approve-data mb-15">
    <p>
      <span class="fw-bold">Employee Name:</span>
      {{matDialogData.userName}}
    </p>
    <p>
      <span class="fw-bold">Date of Skip Request:</span>
      {{matDialogData.date | date:'longDate'}}
    </p>
    <p>
      <span class="fw-bold">Reason:</span>
      {{matDialogData.empComment}}
    </p>
    <p *ngIf="matDialogData?.applSkipRejectOrAccept">
      <span class="fw-bold">Comment:</span>
      {{matDialogData.managerComment}}
    </p>
    <textarea *ngIf="!matDialogData?.applSkipRejectOrAccept" rows="3" cols="50" [(ngModel)]="addManagerComment" placeholder="Type here.." [ngClass]="{'border-clr-red': needManagerComment}" class="manager-comment mb-15"></textarea>
    <div *ngIf="!matDialogData?.applSkipRejectOrAccept">
      <button class="add_btn mr-10" (click)="approveOrRejectSkipDayCall(true)">Approve</button>
      <button class="add_btn_four" (click)="approveOrRejectSkipDayCall(false)">Reject</button>
    </div>
  </div>
</mat-dialog-content>
